import { gql } from '@apollo/client';
import { SaleItemListLightFragment } from '../fragments/SaleItemListLightFragment';
/**
 * @const SaleItemsListLightQuery
 * @since 1.0.0
 */
export const SaleItemsListLightQuery = gql `
  query SaleItemsListLightQuery($input: SaleItemsInput) {
    saleItems(input: $input) {
      items {
        ...SaleItemListLightFragment
      }
      count
    }
  }

  ${SaleItemListLightFragment}
`;
